export default {"src":"/_next/static/media/deco_logo_skillzpowered_balance_bar.092ca5cf.svg","height":23,"width":52,"blurWidth":0,"blurHeight":0};